import { Link } from 'react-router';

export function NoEncontrado() {
  return (
    <section className="panel-vidrio mx-auto max-w-xl text-center">
      <h1 className="text-2xl font-extrabold text-azul-texto">Esta página no existe</h1>
      <p className="mt-2 text-texto-2">Revisa la dirección o vuelve al inicio del panel.</p>
      <Link to="/" className="btn-cs btn-primario mt-6">
        Ir al inicio
      </Link>
    </section>
  );
}
